// extracted by mini-css-extract-plugin
export default {"container":"admin-breadcrumbs_container__SOqoo","item":"admin-breadcrumbs_item__yuSL5"};